const __request = require(`./__request/__request_contentType_json`);

// 城市、机场查询
// 接口文档地址：http://183.58.24.99:9999/swagger-ui.html?tdsourcetag=s_pcqq_aiomsg#/
const citys = (pParameter) => {
  if (!pParameter) pParameter = {};
  pParameter = {
    method: 'post',
    // urlSuffix: '/flight/domestic/citys',
    urlSuffix:'/base/dom/citys',
    data: {
    }
  }

  return __request(pParameter)
}
module.exports = citys;
